import _slicedToArray from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { createModel } from '@rematch/core';
import { affiliateCreatorMarketPlaceApiClient, AffiliateCreatorProfileSortingAlgorithm } from '@/api/affiliate/serv/oec_affiliate_creator_marketplace_api';
import { getRecommendationRequest, getSearchRequest, shouldUseRecommended } from '@/pages/find-creators/creator-marketplace/utils';
import { handleError } from '@/utils/api-error';
import { CreatorListTabsEnum, CreatorListViewModeEnum, MAX_TOTAL_CREATORS_NUMBER, MAX_REQUEST_TIMES, SortByEnum, SortModeEnum, MIN_SINGLE_REQUEST_CREATORS_NUMBER } from '@/pages/find-creators/creator-marketplace/constants';
import { DEFAULT_MAX_INVITE_TIMES } from '@/pages/find-creators/constants';
import { PageType } from '@/pages/find-creators/track';
import { DividedLinePosEnum } from '@/types/creator-profile';
import { getFilterFormInitValue } from '@/pages/find-creators/creator-marketplace/components/search-filter/constant';
var SUGGESTION_RESULT_LIMIT = 20;
export var SearchType = /*#__PURE__*/function (SearchType) {
  SearchType["SearchMore"] = "more";
  SearchType["SearchNew"] = "new";
  return SearchType;
}({});
export var initPagination = {
  size: MIN_SINGLE_REQUEST_CREATORS_NUMBER,
  next_page: 0,
  has_more: true
};
var initialState = {
  restInviteTimes: DEFAULT_MAX_INVITE_TIMES,
  topOffset: 0,
  pagination: initPagination,
  creatorProfiles: [],
  notReferableCreatorProfiles: [],
  listMode: CreatorListViewModeEnum.Table,
  pageType: PageType.Default,
  searchQuery: '',
  searchParams: {
    sortBy: SortByEnum.DEFAULT,
    sortMode: SortModeEnum.DEFAULT,
    creatorListTab: CreatorListTabsEnum.VIDEO,
    referableState: {}
  },
  filterParam: {},
  sortOptions: [],
  sortParams: {
    sortBy: AffiliateCreatorProfileSortingAlgorithm.AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_RECOMMENDATION
  },
  featureGuide: {
    isShowGuideCollectionCreatorListEntry: false,
    isShowGuideTargetInviteEntry: true,
    isShowGuidePromotionDetail: true
  },
  filterFormValue: getFilterFormInitValue(),
  inviteModalProp: {
    visible: false
  },
  isSearchFromUrl: true
};
export var findCreatorsModel = createModel()({
  state: initialState,
  reducers: {
    updateCreatorList: function updateCreatorList(state, list) {
      return _objectSpread(_objectSpread({}, state), {}, {
        creatorProfiles: list
      });
    },
    updateNotReferableCreatorList: function updateNotReferableCreatorList(state, list) {
      return _objectSpread(_objectSpread({}, state), {}, {
        notReferableCreatorProfiles: list
      });
    },
    updateSearchParam: function updateSearchParam(state, searchParams) {
      // When `searchParams` changes, the state of the sorting item should be checked first to determine the value of `referableState`.
      var mergedSearchParams = _objectSpread(_objectSpread({}, state.searchParams), searchParams);
      var sortBy = mergedSearchParams.sortBy,
        sortMode = mergedSearchParams.sortMode;
      var defaultReferableState = {};
      if ((sortBy === SortByEnum.LIVE_GPM || sortBy === SortByEnum.VIDEO_GPM) && sortMode !== SortModeEnum.DEFAULT) {
        defaultReferableState = {
          isGPMReferable: true
        };
      }
      return _objectSpread(_objectSpread({}, state), {}, {
        searchParams: _objectSpread(_objectSpread({}, state.searchParams), {}, {
          referableState: defaultReferableState
        }, searchParams)
      });
    },
    updateFilterFormValue: function updateFilterFormValue(state, filterFormValue) {
      return _objectSpread(_objectSpread({}, state), {}, {
        filterFormValue: filterFormValue
      });
    },
    updateFilterFormRef: function updateFilterFormRef(state, filterFormRef) {
      return _objectSpread(_objectSpread({}, state), {}, {
        filterFormRef: filterFormRef
      });
    },
    updateRemoteOptions: function updateRemoteOptions(state, remoteOptions) {
      return _objectSpread(_objectSpread({}, state), {}, {
        remoteOptions: _objectSpread(_objectSpread({}, state.remoteOptions || {}), remoteOptions)
      });
    },
    updateSortOptions: function updateSortOptions(state, sortOptions) {
      return _objectSpread(_objectSpread({}, state), {}, {
        sortOptions: sortOptions
      });
    },
    updateTotalVideoList: function updateTotalVideoList(state, totalVideoList) {
      return _objectSpread(_objectSpread({}, state), {}, {
        totalVideoList: _objectSpread(_objectSpread({}, state.totalVideoList || {}), totalVideoList)
      });
    },
    updateFilterParam: function updateFilterParam(state, filterParam) {
      return _objectSpread(_objectSpread({}, state), {}, {
        filterParam: filterParam
      });
    },
    // sort function for new version
    updateSortParam: function updateSortParam(state, sortParams) {
      return _objectSpread(_objectSpread({}, state), {}, {
        sortParams: _objectSpread(_objectSpread({}, state.sortParams), sortParams)
      });
    },
    updateFetchParam: function updateFetchParam(state, _ref) {
      var searchParams = _ref.searchParams,
        sortParams = _ref.sortParams,
        filterParams = _ref.filterParams;
      return _objectSpread(_objectSpread({}, state), {}, {
        sortParams: _objectSpread(_objectSpread({}, state.sortParams), sortParams || {}),
        searchParams: _objectSpread(_objectSpread({}, state.searchParams), searchParams || {}),
        filterParam: _objectSpread(_objectSpread({}, state.filterParam), filterParams || {})
      });
    },
    updateListMode: function updateListMode(state, mode) {
      return _objectSpread(_objectSpread({}, state), {}, {
        listMode: mode
      });
    },
    updatePageType: function updatePageType(state, type) {
      return _objectSpread(_objectSpread({}, state), {}, {
        pageType: type
      });
    },
    updatePagination: function updatePagination(state, pagination) {
      return _objectSpread(_objectSpread({}, state), {}, {
        pagination: _objectSpread(_objectSpread({}, state.pagination), pagination)
      });
    },
    updateRestInviteTimes: function updateRestInviteTimes(state, restInviteTimes) {
      return _objectSpread(_objectSpread({}, state), {}, {
        restInviteTimes: restInviteTimes
      });
    },
    updateRecommendationReqId: function updateRecommendationReqId(state, recommendationReqId) {
      return _objectSpread(_objectSpread({}, state), {}, {
        recommendationReqId: recommendationReqId
      });
    },
    updateSearchQuery: function updateSearchQuery(state, searchQuery) {
      return _objectSpread(_objectSpread({}, state), {}, {
        searchQuery: searchQuery
      });
    },
    setTopOffset: function setTopOffset(state, offset) {
      return _objectSpread(_objectSpread({}, state), {}, {
        topOffset: offset
      });
    },
    updateBFRecommendFilterState: function updateBFRecommendFilterState(state, visible) {
      return _objectSpread(_objectSpread({}, state), {}, {
        isShowBlackFridayRecommendFilter: visible
      });
    },
    resetCreatorList: function resetCreatorList(state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        creatorProfiles: [],
        notReferableCreatorProfiles: []
      });
    },
    resetSearchParam: function resetSearchParam(state) {
      var creatorListTab = state.searchParams.creatorListTab;
      return _objectSpread(_objectSpread({}, state), {}, {
        searchParams: _objectSpread(_objectSpread({}, initialState.searchParams), {}, {
          creatorListTab: creatorListTab
        })
      });
    },
    resetState: function resetState() {
      return initialState;
    },
    updateFeatureGuide: function updateFeatureGuide(state, featureGuide) {
      var oldFeatureGuide = state.featureGuide;
      return _objectSpread(_objectSpread({}, state), {}, {
        featureGuide: _objectSpread(_objectSpread({}, oldFeatureGuide), featureGuide)
      });
    },
    updateInviteModalProp: function updateInviteModalProp(state, inviteModalProp) {
      return _objectSpread(_objectSpread({}, state), {}, {
        inviteModalProp: inviteModalProp
      });
    },
    updateIsSearchFromUrl: function updateIsSearchFromUrl(state, isSearchFromUrl) {
      return _objectSpread(_objectSpread({}, state), {}, {
        isSearchFromUrl: isSearchFromUrl
      });
    }
  },
  effects: function effects(dispatch) {
    return {
      getSuggestionList: function getSuggestionList(params) {
        return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var query, sug_scene, suggestionList;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                query = params.query, sug_scene = params.sugScene;
                _context.prev = 1;
                _context.next = 4;
                return affiliateCreatorMarketPlaceApiClient.GetAffiliateCreatorSearchSuggestionsQuery({
                  request: {
                    query: query,
                    sug_scene: sug_scene,
                    size: SUGGESTION_RESULT_LIMIT
                  }
                });
              case 4:
                suggestionList = _context.sent;
                return _context.abrupt("return", suggestionList);
              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                return _context.abrupt("return", Promise.reject(_context.t0));
              case 11:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[1, 8]]);
        }))();
      },
      getCreatorList: function getCreatorList(params, state) {
        return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var searchParams, searchType, hasCreatorTypeTabFilterPermission, shouldResetCreatorList, inFilterExperimentGroup, _findCreatorsModel, creatorProfiles, notReferableCreatorProfiles, isRecommend, totalCreatorData, newCreatorConnectList, newCreatorIds, restRequestTimes, recommendationId, paginationParams, _loop;
          return _regeneratorRuntime().wrap(function _callee2$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                searchParams = params.searchParams, searchType = params.searchType, hasCreatorTypeTabFilterPermission = params.hasCreatorTypeTabFilterPermission, shouldResetCreatorList = params.shouldResetCreatorList, inFilterExperimentGroup = params.inFilterExperimentGroup;
                if (shouldResetCreatorList) {
                  dispatch.findCreatorsModel.resetCreatorList();
                }
                _findCreatorsModel = state.findCreatorsModel, creatorProfiles = _findCreatorsModel.creatorProfiles, notReferableCreatorProfiles = _findCreatorsModel.notReferableCreatorProfiles;
                isRecommend = shouldUseRecommended(searchParams);
                totalCreatorData = [];
                newCreatorConnectList = [];
                newCreatorIds = [];
                restRequestTimes = MAX_REQUEST_TIMES;
                recommendationId = state.findCreatorsModel.recommendationReqId;
                paginationParams = searchType === SearchType.SearchNew ? initPagination : state.findCreatorsModel.pagination;
                _context3.prev = 10;
                _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                  var request, resList, creator_profile_list, _resList$creator_conn, creator_connect_info_list, next_pagination, recommendation_req_id, creatorData, _resList$data, _request, _resList, _ref2, _creator_profile_list, shop_invite_info, _next_pagination, _recommendation_req_id, _creatorData;
                  return _regeneratorRuntime().wrap(function _loop$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!inFilterExperimentGroup) {
                          _context2.next = 16;
                          break;
                        } // 在实验组里，最新的
                        restRequestTimes -= 1;
                        request = {
                          query: searchParams.query,
                          pagination: {
                            size: paginationParams.size,
                            search_key: paginationParams.search_key,
                            next_item_cursor: paginationParams.next_item_cursor,
                            page: paginationParams.next_page
                          },
                          query_type: searchParams.queryType,
                          filter_params: state.findCreatorsModel.filterParam,
                          algorithm: state.findCreatorsModel.sortParams.sortBy // SortConfigs[state.findCreatorsModel.sortParams.sortBy]
                          //   .algorithm,
                        };
                        _context2.next = 5;
                        return affiliateCreatorMarketPlaceApiClient.FindAffiliateCreator(request);
                      case 5:
                        resList = _context2.sent;
                        creator_profile_list = resList.creator_profile_list, _resList$creator_conn = resList.creator_connect_info_list, creator_connect_info_list = _resList$creator_conn === void 0 ? [] : _resList$creator_conn, next_pagination = resList.next_pagination, recommendation_req_id = resList.recommendation_req_id; // update next pagination
                        paginationParams = _objectSpread(_objectSpread({}, initPagination), next_pagination); // update new creator connect
                        newCreatorConnectList.push.apply(newCreatorConnectList, _toConsumableArray(creator_connect_info_list));
                        newCreatorIds.push.apply(newCreatorIds, _toConsumableArray((creator_profile_list === null || creator_profile_list === void 0 ? void 0 : creator_profile_list.map(function (item) {
                          var _item$creator_oecuid;
                          return ((_item$creator_oecuid = item.creator_oecuid) === null || _item$creator_oecuid === void 0 ? void 0 : _item$creator_oecuid.value) || '';
                        })) || []));
                        creatorData = creator_profile_list !== null && creator_profile_list !== void 0 ? creator_profile_list : [];
                        creatorData = creatorData.map(function (item, idx) {
                          return _objectSpread(_objectSpread({}, item), {}, {
                            // handle additional result divide line
                            isDividedLine:
                            // eslint-disable-next-line no-nested-ternary
                            idx === (next_pagination === null || next_pagination === void 0 ? void 0 : next_pagination.search_partition_index) ? DividedLinePosEnum.ABOVE : next_pagination !== null && next_pagination !== void 0 && next_pagination.search_partition_index &&
                            // index exists
                            idx === creatorData.length - 1 &&
                            // ensure it's the last one
                            creatorData.length <= (next_pagination === null || next_pagination === void 0 ? void 0 : next_pagination.search_partition_index) // given index exceeds the length of entire list
                            ? DividedLinePosEnum.BELOW // case: if all items after index are screened by back-end, the line should be shown below the last item
                            : undefined,
                            recommendation_req_id: typeof recommendation_req_id === 'string' ? recommendation_req_id : undefined
                          });
                        });
                        totalCreatorData.push.apply(totalCreatorData, _toConsumableArray(creatorData));
                        dispatch.findCreatorsModel.updateRecommendationReqId(recommendation_req_id !== null && recommendation_req_id !== void 0 ? recommendation_req_id : '');
                        _context2.next = 37;
                        break;
                      case 16:
                        _request = !isRecommend ? getSearchRequest(searchParams, _objectSpread(_objectSpread({}, paginationParams), {}, {
                          size: 20
                        }), hasCreatorTypeTabFilterPermission) : getRecommendationRequest(searchParams, _objectSpread(_objectSpread({}, paginationParams), {}, {
                          size: 20
                        }), hasCreatorTypeTabFilterPermission);
                        restRequestTimes -= 1;
                        if (isRecommend) {
                          _context2.next = 24;
                          break;
                        }
                        _context2.next = 21;
                        return affiliateCreatorMarketPlaceApiClient.GetAffiliateCreatorSearchQuery({
                          request: _request
                        });
                      case 21:
                        _context2.t0 = _context2.sent;
                        _context2.next = 27;
                        break;
                      case 24:
                        _context2.next = 26;
                        return affiliateCreatorMarketPlaceApiClient.GetAffiliateCreatorRecommendationQuery({
                          request: _request
                        });
                      case 26:
                        _context2.t0 = _context2.sent;
                      case 27:
                        _resList = _context2.t0;
                        _ref2 = (_resList$data = _resList.data) !== null && _resList$data !== void 0 ? _resList$data : {}, _creator_profile_list = _ref2.creator_profile_list, shop_invite_info = _ref2.shop_invite_info, _next_pagination = _ref2.next_pagination, _recommendation_req_id = _ref2.recommendation_req_id; // update next pagination
                        paginationParams = _objectSpread(_objectSpread({}, initPagination), {}, {
                          size: 20
                        }, _next_pagination);
                        _creatorData = _creator_profile_list !== null && _creator_profile_list !== void 0 ? _creator_profile_list : [];
                        newCreatorIds.push.apply(newCreatorIds, _toConsumableArray((_creator_profile_list === null || _creator_profile_list === void 0 ? void 0 : _creator_profile_list.map(function (item) {
                          var _item$creator_oecuid$, _item$creator_oecuid2;
                          return (_item$creator_oecuid$ = (_item$creator_oecuid2 = item.creator_oecuid) === null || _item$creator_oecuid2 === void 0 ? void 0 : _item$creator_oecuid2.value) !== null && _item$creator_oecuid$ !== void 0 ? _item$creator_oecuid$ : '';
                        })) || []));
                        _creatorData = _creatorData.map(function (item, idx) {
                          return _objectSpread(_objectSpread({}, item), {}, {
                            recommendation_req_id: typeof _recommendation_req_id === 'string' ? _recommendation_req_id : undefined,
                            // handle additional result divide line
                            isDividedLine:
                            // eslint-disable-next-line no-nested-ternary
                            idx === (_next_pagination === null || _next_pagination === void 0 ? void 0 : _next_pagination.search_partition_index) ? DividedLinePosEnum.ABOVE : _next_pagination !== null && _next_pagination !== void 0 && _next_pagination.search_partition_index &&
                            // index exists
                            idx === _creatorData.length - 1 &&
                            // ensure it's the last one
                            _creatorData.length <= (_next_pagination === null || _next_pagination === void 0 ? void 0 : _next_pagination.search_partition_index) // given index exceeds the length of entire list
                            ? DividedLinePosEnum.BELOW // case: if all items after index are screened by back-end, the line should be shown below the last item
                            : undefined
                          });
                        });
                        dispatch.findCreatorsModel.updateRecommendationReqId(_recommendation_req_id !== null && _recommendation_req_id !== void 0 ? _recommendation_req_id : '');
                        recommendationId = _recommendation_req_id !== null && _recommendation_req_id !== void 0 ? _recommendation_req_id : '';
                        if (shop_invite_info) {
                          Object.entries(shop_invite_info).forEach(function (_ref3) {
                            var _ref4 = _slicedToArray(_ref3, 2),
                              oecId = _ref4[0],
                              invitationInfo = _ref4[1];
                            _creatorData = _creatorData.map(function (item) {
                              var _item$creator_oecuid3;
                              return ((_item$creator_oecuid3 = item.creator_oecuid) === null || _item$creator_oecuid3 === void 0 ? void 0 : _item$creator_oecuid3.value) === oecId ? _objectSpread(_objectSpread({}, item), {}, {
                                invitationInfo: invitationInfo
                              }) : item;
                            });
                          });
                        }
                        totalCreatorData.push.apply(totalCreatorData, _toConsumableArray(_creatorData));
                      case 37:
                      case "end":
                        return _context2.stop();
                    }
                  }, _loop);
                });
              case 12:
                if (!(totalCreatorData.length < MIN_SINGLE_REQUEST_CREATORS_NUMBER && restRequestTimes > 0 && totalCreatorData.length + creatorProfiles.length + notReferableCreatorProfiles.length < MAX_TOTAL_CREATORS_NUMBER && paginationParams.has_more)) {
                  _context3.next = 16;
                  break;
                }
                return _context3.delegateYield(_loop(), "t0", 14);
              case 14:
                _context3.next = 12;
                break;
              case 16:
                return _context3.abrupt("return", {
                  totalCreatorData: totalCreatorData,
                  newCreatorIds: newCreatorIds,
                  newCreatorConnectList: newCreatorConnectList,
                  nextPagination: paginationParams,
                  recommendationId: recommendationId
                });
              case 19:
                _context3.prev = 19;
                _context3.t1 = _context3["catch"](10);
                console.error('e', _context3.t1);
                throw handleError(_context3.t1);
              case 23:
              case "end":
                return _context3.stop();
            }
          }, _callee2, null, [[10, 19]]);
        }))();
      }
    };
  }
});